<a
  i18n-routerLink="@@HEADER.FLOATING_CART.SEE_ORDER.LINK"
  routerLink="/shop-order.shtml"
  class="vc-btn vc-btn--primary vc-btn--large vc-btn--full"
  [ngClass]="{hasLoader: pending}"
  (click)="launchLoader()"
  i18n="@@HEADER.FLOATING_CART.SEE_ORDER.LABEL"
  >Proceed to checkout</a
>
